import { useRouteError } from 'react-router-dom';

import { ErrorMessage } from '@repo/ui/fixtures/errorBoundary/components/ErrorMessage/ErrorMessage';

/**
 * Root route error boundary for the `createBrowserRouter` tree. React Router
 * 6.4+ renders this in place of the routed page when a loader, action, or
 * render throws anywhere under the root route, so a failure gets this
 * app-specific fallback instead of React Router's generic default screen.
 */
export function RootErrorBoundary() {
  const error = useRouteError();
  console.error('Unhandled route error', error);
  return <ErrorMessage />;
}
